import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { cn } from '../../../../lib/utils';
import { DropdownMenuComponent } from '../../dropdown-menu.component';

@Component({
  selector: 'app-dropdown-menu-item',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dropdown-menu-item.component.html',
})
export class DropdownMenuItemComponent {
  @Input() className: string = '';
  private dropdown = inject(DropdownMenuComponent);

  get classes() {
    return cn(
      'relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors hover:bg-accent hover:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
      this.className,
    );
  }

  onClick() {
    this.dropdown.close();
  }
}
